import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import {
  Thead,
  Td,
  Tr,
  Th,
  CheckboxLabel
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const TrackerServices = ({ serviceData, serviceName }) => {
  if (serviceData && !serviceData.length) return null;

  const getCheckboxLabel = deviceName => {
    if (deviceName === 'Raven+') {
      return 'Access to MyGeotab Portal';
    }
    return '50% in US';
  };

  return (
    <table>
      <Thead>
        <Tr>
          <Th width="55%">{serviceName}</Th>
          <Th width="10%">Term</Th>
          <Th width="10%">Unit Price</Th>
          <Th width="10%">Units</Th>
          <Th width="15%">Total monthly fee</Th>
        </Tr>
      </Thead>
      <tbody>
        {serviceData &&
          serviceData.map(data => {
            const {
              name,
              device,
              term,
              quantity,
              unitPrice,
              fiftyPercentInUS
            } = data;
            return (
              <Tr>
                <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                  <div>
                    <p>
                      {name} - {device}
                    </p>
                    {fiftyPercentInUS && (
                      <CheckboxLabel>{getCheckboxLabel(device)}</CheckboxLabel>
                    )}
                  </div>
                </Td>
                <Td>{term}</Td>
                <Td>{getFormattedPricing(unitPrice)}</Td>
                <Td>{quantity}</Td>
                <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
              </Tr>
            );
          })}
      </tbody>
    </table>
  );
};

TrackerServices.propTypes = {
  serviceName: PropTypes.string.isRequired,
  serviceData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      device: PropTypes.string,
      term: PropTypes.string,
      quantity: PropTypes.number,
      unitPrice: PropTypes.number,
      fiftyPercentInUS: PropTypes.bool
    })
  ).isRequired
};

const SummaryRatePlan = ({ orderData, total }) => {
  const {
    fleetTrackingServices,
    assetTrackingServices,
    videoTelematicServices,
    tattleSystemServices,
    iotProductSelected
  } = orderData;

  const {
    contentfulValues: { valuePowerFleet }
  } = useLocalizedStringsContext();

  return (
    <>
      {total > 0 && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>{iotProductSelected === valuePowerFleet ? 'Monthly Subscription' : 'Rate Plan'}</Typography>
          <Box>
            <TrackerServices
              serviceData={fleetTrackingServices}
              serviceName="Fleet Tracking Service"
            />
            <TrackerServices
              serviceData={assetTrackingServices}
              serviceName="Asset Tracking Service"
            />
            <TrackerServices
              serviceData={videoTelematicServices}
              serviceName="Video Telematic Service"
            />
            <TrackerServices
              serviceData={tattleSystemServices}
              serviceName="Tattle System Service"
            />
            <div
              style={{
                background: '#f4f4f4',
                border: '1px solid #e3e3e3',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '1rem 3rem'
              }}
            >
              <p style={{ marginLeft: '16rem', fontWeight: '600' }}>Total</p>
              <p style={{ marginRight: '0.65rem', fontWeight: '600' }}>
                {getFormattedPricing(total)}
              </p>
            </div>
          </Box>
        </StackView>
      )}
    </>
  );
};

SummaryRatePlan.propTypes = {
  orderData: PropTypes.shape({
    fleetTrackingServices: PropTypes.arrayOf(PropTypes.shape({})),
    assetTrackingServices: PropTypes.arrayOf(PropTypes.shape({})),
    videoTelematicServices: PropTypes.arrayOf(PropTypes.shape({})),
    tattleSystemServices: PropTypes.arrayOf(PropTypes.shape({})),
    iotProductSelected: PropTypes.string
  }).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryRatePlan;
